export { default as YotpoReviewsState } from './YotpoReviewsState'



// WEBPACK FOOTER //
// ./src/components/yotpoReviewsState/index.js